<div class="person-info__container">
  <div class="person-info__name" [title]="roles()" *ngIf="displayName(); else notAuthenticated">{{ displayName() }}</div>
  <ng-template #notAuthenticated>
    <div class="person-info__name">{{ "webPos.UserNotAuthenticated" | translate }}</div>
  </ng-template>
  <div class="person-info__branch" *ngIf="displayName()">{{ "webPos.Branch" | translate }} {{ businessUnitID() }} {{ currencyCode() }}</div>
</div>
